import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import EnergyEffLinkBoxRow from '../components/EnergyEffLinkBoxRow';

export type EnergyEfficiencyPageProps = {};

const EnergyEfficiencyPage: React.FC<EnergyEfficiencyPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "energy-efficiency",
          defaultMessage: "Energy Efficiency"
        })}
      />
      <EnergyEffLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-20">
        <div className="w-full">
          <img className="w-full" src="/img/plant-bulb.png" alt="MCB - Energy Efficiency" />
        </div>
      </div>
    </div>
  );
}

export default EnergyEfficiencyPage;